import React, { Component } from 'react';
import './Zimmer.css';
import SectionHeader from '../SectionHeader/SectionHeader';
import { Link } from 'react-router';

class Zimmer extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        if (typeof this.props.onRefs === 'function') {
            this.props.onRefs("hotel", this.refs);
        }
    }

    static propTypes =  {
        onChange:   React.PropTypes.func,
        title: React.PropTypes.string,
        rooms:   React.PropTypes.array
    }

    clickPage = (idx, e) =>  {
        //console.log(("clickPage - idx: " + idx.valueOf());
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(idx, "page");
        }
    }

    handleRoomClick = (idx, e) =>  {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(idx, "room", "hotel");
        }
    }

    clickButton1 = () =>  {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(0, "page", "hotel");
        }
    }

    clickButton2 = () =>  {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(1, "page", "hotel");
        }
    }

    clickButton3 = () =>  {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(2, "page", "hotel");
        }
    }

  render() {
      var appartments = [];

      if (this.props.rooms !== undefined) {
          var roomList = this.props.rooms;

          if (roomList !== undefined) {

              for (var i=0; i<roomList.length; i++) {
                  var r = roomList[i];
                  if (r.thumb !== undefined && r.images !== undefined && r.images.length > 0) {
                      r.thumbUrl = "";
                      for (var j=0; j<r.images.length; j++) {
                          var img = r.images[j];
                          if (img.name === r.thumb) {
                              r.thumbUrl = img.url;
                              break;
                          }
                      }
                  }
                  ////console.log(("Hotel - r.thumbUrl: " + r.thumbUrl);
              }


              var k = 0;
              appartments = roomList.map((room) =>
                  <div key={"app_" + (k++).toString()} className="col-lg-3 col-md-3 col-xs-6">
                      <Link to={"/zimmer/" + (k-1)}>
                          <div className="AppartmentPanel">
                              <div className="Thumb">
                                  <img src={room.thumbUrl} width="100%" alt={room.headline}/>
                              </div>
                              <h3>{room.headline}</h3>
                          </div>
                      </Link>
                  </div>
              );
          }

      }

      var imgUrl = "";
      if (this.props.images && this.props.images.length > 0) {
          imgUrl = this.props.images[0].url;
      }

    return (
        <section className="Zimmer" style={{backgroundImage: 'url(' + imgUrl + ')'}}>
          <SectionHeader title={this.props.title}></SectionHeader>
          <div className="Content">
              <div className="row">
                {appartments}
              </div>

          </div>

        </section>
    );
  }
}

export default Zimmer;



// WEBPACK FOOTER //
// ./src/components/Zimmer/Zimmer.js